/* ================================================================
   MO — RECHERCHE « CLUB, PUIS VERSION » (01/10)

   Remplace l'ouverture de la recherche Dawn : un clic sur la loupe
   ouvre ce panneau plein écran. Si ce fichier ne se charge pas, la
   loupe ouvre l'ancienne recherche, rien n'est cassé.

   Parcours :
   1. À l'ouverture : « Choisis ton équipe », 8 ronds (liste VEDETTES).
   2. On touche un rond, ou on tape : la recherche part vers
      /search?...&view=mo (templates/search.mo.liquid, en JSON, 50
      produits par page, 2 pages au plus).
   3. Les résultats sont rangés par équipe. Une seule équipe : on va
      droit à sa fiche. Plusieurs : une ligne par équipe.
   4. Fiche club : les maillots rangés par version (Domicile,
      Extérieur, Concept…), avec la carte produit du site (.moc).

   ACCENTS : on ne sait pas si la recherche Shopify confond « bresil »
   et « brésil ». Pour ne rien rater, un mot qui a une variante
   (ACCENTS) part dans les deux écritures et les résultats sont
   fusionnés.

   Installé une seule fois ; tout passe par délégation sur document.
   ================================================================ */
(function () {
  if (window.__moRecherche) return;
  window.__moRecherche = true;

  /* ---- les 8 ronds de départ : à modifier ici ---- */
  var VEDETTES = [
    { nom: 'France',      q: 'france',      fond: '#24346F', txt: '#FFFFFF', sigle: 'FRA' },
    { nom: 'PSG',         q: 'psg',         fond: '#1B2A4E', txt: '#FFFFFF', sigle: 'PSG' },
    { nom: 'Brésil',      q: 'brésil',      fond: '#F6D33C', txt: '#1F7A5A', sigle: 'BRA' },
    { nom: 'Portugal',    q: 'portugal',    fond: '#B3212E', txt: '#FFFFFF', sigle: 'POR' },
    { nom: 'Real Madrid', q: 'real madrid', fond: '#F4F4F2', txt: '#B8965A', sigle: 'RMA' },
    { nom: 'Barcelone',   q: 'barcelone',   fond: '#A50044', txt: '#F6D33C', sigle: 'BAR' },
    { nom: 'Espagne',     q: 'espagne',     fond: '#C8102E', txt: '#F6D33C', sigle: 'ESP' },
    { nom: 'Algérie',     q: 'algérie',     fond: '#1F7A5A', txt: '#FFFFFF', sigle: 'ALG' }
  ];

  /* ---- reconnaître l'équipe dans un titre (forme sans accents) ---- */
  var EQUIPES = [
    ['real madrid','Real Madrid'],['fc barcelone','Barcelone'],['barcelone','Barcelone'],['atletico madrid','Atlético Madrid'],['atletico','Atlético Madrid'],
    ['paris fc','Paris FC'],['psg','PSG'],['paris saint germain','PSG'],
    ['manchester city','Manchester City'],['man city','Manchester City'],['manchester united','Manchester United'],['man united','Manchester United'],
    ['inter miami','Inter Miami'],['inter milan','Inter Milan'],['inter','Inter Milan'],['ac milan','AC Milan'],['milan','AC Milan'],
    ['as roma','AS Roma'],['roma','AS Roma'],['juventus','Juventus'],['naples','Naples'],['napoli','Naples'],
    ['bayern munich','Bayern Munich'],['bayern','Bayern Munich'],['dortmund','Dortmund'],['leipzig','Leipzig'],
    ['marseille','Marseille'],['lyon','Lyon'],['monaco','Monaco'],['lille','Lille'],['rc lens','RC Lens'],['lens','RC Lens'],['strasbourg','Strasbourg'],
    ['liverpool','Liverpool'],['arsenal','Arsenal'],['chelsea','Chelsea'],['tottenham','Tottenham'],['newcastle','Newcastle'],['aston villa','Aston Villa'],
    ['everton','Everton'],['brighton','Brighton'],['west ham','West Ham'],['leicester','Leicester'],
    ['benfica','Benfica'],['porto','Porto'],['sporting','Sporting'],['ajax','Ajax'],['celtic','Celtic'],
    ['flamengo','Flamengo'],['corinthians','Corinthians'],['fluminense','Fluminense'],['santos','Santos'],['boca juniors','Boca Juniors'],['boca','Boca Juniors'],['river plate','River Plate'],
    ['al nassr','Al-Nassr'],['al hilal','Al-Hilal'],['chivas','Chivas'],['tigres','Tigres'],['palestino','CD Palestino'],
    ['france','France'],['bresil','Brésil'],['portugal','Portugal'],['espagne','Espagne'],['algerie','Algérie'],['maroc','Maroc'],
    ['senegal','Sénégal'],['nigeria','Nigeria'],['mali','Mali'],['cote d ivoire','Côte d’Ivoire'],['argentine','Argentine'],['colombie','Colombie'],
    ['uruguay','Uruguay'],['mexique','Mexique'],['usa','USA'],['etats unis','USA'],['canada','Canada'],['costa rica','Costa Rica'],['equateur','Équateur'],
    ['japon','Japon'],['coree du sud','Corée du Sud'],['coree','Corée du Sud'],['palestine','Palestine'],['allemagne','Allemagne'],['angleterre','Angleterre'],
    ['italie','Italie'],['belgique','Belgique'],['norvege','Norvège'],['turquie','Turquie'],['pays bas','Pays-Bas'],['croatie','Croatie']
  ];

  /* mots tapés autrement que dans les titres */
  var SYN = { barca: 'barcelone', 'barça': 'barcelone', ext: 'extérieur', exte: 'extérieur', dom: 'domicile',
              kids: 'enfant', kid: 'enfant', enfants: 'enfant', veste: 'coupe vent', vestes: 'coupe vent',
              realmadrid: 'real madrid', mancity: 'manchester city' };
  /* mots qu'on cherche avec et sans accent */
  var ACCENTS = { bresil: 'brésil', 'brésil': 'bresil', retro: 'rétro', 'rétro': 'retro', exterieur: 'extérieur', 'extérieur': 'exterieur',
                  algerie: 'algérie', 'algérie': 'algerie', etoile: 'étoile', 'étoile': 'etoile', senegal: 'sénégal', 'sénégal': 'senegal',
                  survetement: 'survêtement', 'survêtement': 'survetement', atletico: 'atlético', 'atlético': 'atletico' };

  /* même coupe que snippets/mo-carte.liquid : club / version */
  var CLES = '|DOMICILE|EXTÉRIEUR|EXTERIEUR|THIRD|THRID|FOURTH|CONCEPT|RETRO|RÉTRO|ENTRAINEMENT|ENTRAINMENT|ENTRAÎNEMENT|GARDIEN|MANCHES|POLO|SPECIAL|SPÉCIAL|EDITION|ÉDITION|BACK2BACK|NIGHT|PLAYER|ENFANT|ENFANTS|KIDS|VINTAGE|TRAINING|AWAY|HOME|NOIR|BLANC|ROSE|VERT|BLEU|BEIGE|ROUGE|JAUNE|GRIS|—|-|';

  var ORDRE = ['Domicile','Extérieur','Third','Concept','Rétro','Player','Manches longues','Enfant','Ensemble','Veste','Survêtement','Gardien','Autre'];

  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function couper(titre) {
    var m = String(titre).split(/\s+/).filter(Boolean), i = 1;
    for (; i < m.length; i++) {
      if (CLES.indexOf('|' + m[i].toUpperCase() + '|') !== -1) break;
      if (/^[0-9]/.test(m[i])) break;
    }
    if (i >= m.length) return { club: titre, ver: '' };
    var v = m.slice(i).join(' ').toLowerCase();
    return { club: m.slice(0, i).join(' '), ver: v.charAt(0).toUpperCase() + v.slice(1) };
  }

  function equipeDe(titre) {
    var n = ' ' + norm(titre).replace(/[^a-z0-9]+/g, ' ') + ' ', meilleur = null;
    for (var k = 0; k < EQUIPES.length; k++) {
      var cle = EQUIPES[k][0], i = n.indexOf(' ' + cle + ' ');
      if (i === -1) continue;
      if (!meilleur || i < meilleur.i || (i === meilleur.i && cle.length > meilleur.l)) meilleur = { i: i, l: cle.length, nom: EQUIPES[k][1] };
    }
    if (meilleur) return meilleur.nom;
    var c = couper(titre).club.toLowerCase();
    return c.replace(/(^|\s)\S/g, function (x) { return x.toUpperCase(); });
  }

  function categorie(titre) {
    var u = String(titre).toUpperCase();
    if (/ENFANT|KIDS/.test(u)) return 'Enfant';
    if (/PLAYER/.test(u)) return 'Player';
    if (/RETRO|RÉTRO/.test(u)) return 'Rétro';
    if (/COUPE VENT|VESTE/.test(u)) return 'Veste';
    if (/SURV[EÊ]TEMENT/.test(u)) return 'Survêtement';
    if (/ENSEMBLE/.test(u)) return 'Ensemble';
    if (/MANCHES LONGUES/.test(u)) return 'Manches longues';
    if (/CONCEPT|JACQUEMUS|NIGHT|JEFE|[EÉ]DITION|SP[EÉ]CIAL/.test(u)) return 'Concept';
    if (/GARDIEN/.test(u)) return 'Gardien';
    if (/THIRD|THRID|FOURTH/.test(u)) return 'Third';
    if (/EXT[EÉ]RIEUR|AWAY/.test(u)) return 'Extérieur';
    if (/DOMICILE|HOME|BACK2BACK/.test(u)) return 'Domicile';
    return 'Autre';
  }

  function rond(nom) {
    var v = null;
    for (var i = 0; i < VEDETTES.length; i++) if (VEDETTES[i].nom === nom) v = VEDETTES[i];
    var fond = v ? v.fond : '#16161A', txt = v ? v.txt : '#FFFFFF';
    var sigle = v ? v.sigle : norm(nom).replace(/[^a-z]/g, '').slice(0, 3).toUpperCase();
    return '<span class="mor__rond" style="background-color:' + fond + ';color:' + txt + '" aria-hidden="true">' + esc(sigle) + '</span>';
  }

  function carte(p) {
    var c = couper(p.t);
    return '<a class="moc" href="' + esc(p.u) + '">'
      + '<span class="moc__tuile">'
      + (p.i ? '<img class="moc__img" src="' + esc(p.i) + '" alt="' + esc(p.t) + '" width="400" height="400" loading="lazy" decoding="async">' : '')
      + (p.d === false ? '<span class="moc__epuise">Épuisé</span>' : '')
      + '<span class="moc__plus" aria-hidden="true"><svg viewBox="0 0 12 12" fill="none"><path d="M6 1v10M1 6h10" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"/></svg></span>'
      + '</span>'
      + '<span class="moc__club">' + esc(c.club) + '</span>'
      + '<span class="moc__version">' + esc(c.ver) + '</span>'
      + '<span class="moc__prix">' + (p.v ? '<small>dès</small>' : '') + '<b>' + esc(p.p) + '</b>' + (p.c ? '<s>' + esc(p.c) + '</s>' : '') + '</span>'
      + '</a>';
  }

  function pluriel(n, mot) { return n + ' ' + mot + (n > 1 ? 's' : ''); }

  /* ================= requêtes ================= */
  var RACINE_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};

  function preparer(q) {
    return q.trim().split(/\s+/).filter(Boolean).map(function (m) {
      var b = m.toLowerCase();
      return SYN[b] || SYN[norm(b)] || b;
    }).join(' ');
  }
  function variantes(q) {
    var a = preparer(q), mots = a.split(' '), autre = mots.map(function (m) { return ACCENTS[m] || m; }).join(' ');
    return autre !== a ? [a, autre] : [a];
  }
  function lirePage(q, page) {
    var url = RACINE_URL + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&view=mo' + (page > 1 ? '&page=' + page : '');
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (t) { return JSON.parse(t.slice(t.indexOf('{'), t.lastIndexOf('}') + 1)); });
  }
  function lireTout(q) {
    return lirePage(q, 1).then(function (j) {
      if (j.pages > 1) return lirePage(q, 2).then(function (j2) { j.produits = j.produits.concat(j2.produits); return j; });
      return j;
    });
  }
  function chercher(q) {
    var cle = norm(preparer(q));
    if (cache[cle]) return Promise.resolve(cache[cle]);
    return Promise.all(variantes(q).map(lireTout)).then(function (listes) {
      var vus = {}, produits = [], total = 0;
      listes.forEach(function (j) {
        total = Math.max(total, j.total || 0);
        (j.produits || []).forEach(function (p) { if (!vus[p.u]) { vus[p.u] = 1; produits.push(p); } });
      });
      produits.forEach(function (p) { p.eq = equipeDe(p.t); p.cat = categorie(p.t); });
      var res = { produits: produits, total: Math.max(total, produits.length) };
      cache[cle] = res;
      return res;
    });
  }

  /* ================= panneau ================= */
  var el = null, champ = null, corps = null, zone = null, declencheur = null, minuteur = null, tour = 0;
  var etat = { vue: 'accueil', q: '', res: null, club: null, version: 'Tout', depuis: 'accueil' };

  function construire() {
    el = document.createElement('div');
    el.className = 'mor';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Recherche');
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<form class="mor__barre" role="search" action="' + RACINE_URL + 'search" method="get">'
      + '<label class="mor__champ">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></svg>'
      + '<input type="search" name="q" placeholder="Ton équipe, un maillot…" aria-label="Rechercher un maillot" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" enterkeyhint="search">'
      + '<button type="button" class="mor__effacer" aria-label="Effacer">×</button>'
      + '</label>'
      + '<input type="hidden" name="type" value="product">'
      + '<button type="button" class="mor__annuler">Annuler</button>'
      + '</form>'
      + '<div class="mor__corps"><div class="mor__dedans" aria-live="polite"></div></div>';
    document.body.appendChild(el);
    champ = el.querySelector('input[name="q"]');
    corps = el.querySelector('.mor__corps');
    zone = el.querySelector('.mor__dedans');

    champ.addEventListener('input', function () {
      el.querySelector('.mor__champ').classList.toggle('plein', champ.value !== '');
      clearTimeout(minuteur);
      minuteur = setTimeout(function () { lancer(champ.value, null); }, 260);
    });
    el.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      clearTimeout(minuteur);
      champ.blur();
      lancer(champ.value, null);
    });
    el.querySelector('.mor__effacer').addEventListener('click', function () {
      champ.value = '';
      el.querySelector('.mor__champ').classList.remove('plein');
      accueil();
      champ.focus();
    });
    el.querySelector('.mor__annuler').addEventListener('click', fermer);
    /* sur document : après un nouveau rendu, le bouton touché a disparu et le focus est retombé sur la page */
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('ouvert')) fermer(); });

    zone.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      if (b.hasAttribute('data-vedette')) {
        var v = VEDETTES[+b.getAttribute('data-vedette')];
        champ.value = v.nom;
        el.querySelector('.mor__champ').classList.add('plein');
        lancer(v.q, v.nom);
      } else if (b.hasAttribute('data-equipe')) {
        etat.club = b.getAttribute('data-equipe'); etat.version = 'Tout'; etat.depuis = 'resultats'; etat.vue = 'club';
        rendre(); corps.scrollTop = 0;
      } else if (b.hasAttribute('data-version')) {
        etat.version = b.getAttribute('data-version');
        rendre();
      } else if (b.hasAttribute('data-retour')) {
        if (etat.depuis === 'resultats') { etat.vue = 'resultats'; rendre(); }
        else { champ.value = ''; el.querySelector('.mor__champ').classList.remove('plein'); accueil(); }
        corps.scrollTop = 0;
      }
    });
  }

  function ouvrir(source) {
    if (!el) construire();
    declencheur = source || null;
    el.classList.add('ouvert');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mor-bloque');
    if (!champ.value) accueil();
    champ.focus();               /* dans le clic : le clavier du téléphone s'ouvre */
  }
  function fermer() {
    if (!el) return;
    el.classList.remove('ouvert');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mor-bloque');
    champ.blur();
    if (declencheur && declencheur.focus) { try { declencheur.focus({ preventScroll: true }); } catch (e) {} }
  }

  function accueil() {
    tour++;
    etat = { vue: 'accueil', q: '', res: null, club: null, version: 'Tout', depuis: 'accueil' };
    rendre();
  }

  function lancer(q, clubImpose) {
    q = String(q || '').trim();
    if (q.length < 2) { accueil(); return; }
    var monTour = ++tour;
    etat.q = q; etat.vue = 'charge'; rendre();
    chercher(q).then(function (res) {
      if (monTour !== tour) return;
      etat.res = res; etat.version = 'Tout';
      var liste = clubImpose ? res.produits.filter(function (p) { return p.eq === clubImpose; }) : res.produits;
      if (clubImpose && liste.length) { etat.club = clubImpose; etat.depuis = 'accueil'; etat.vue = 'club'; }
      else if (!res.produits.length) { etat.vue = 'vide'; }
      else {
        var g = groupes(res.produits);
        if (g.length === 1) { etat.club = g[0].nom; etat.depuis = 'accueil'; etat.vue = 'club'; }
        else { etat.vue = 'resultats'; }
      }
      rendre(); corps.scrollTop = 0;
    }).catch(function () {
      if (monTour !== tour) return;
      etat.vue = 'erreur'; rendre();
    });
  }

  function groupes(produits) {
    var o = {}, ordre = [];
    produits.forEach(function (p) { if (!o[p.eq]) { o[p.eq] = 0; ordre.push(p.eq); } o[p.eq]++; });
    return ordre.map(function (n) { return { nom: n, n: o[n] }; }).sort(function (a, b) { return b.n - a.n; });
  }

  function grilleClubs() {
    return '<div class="mor__clubs">' + VEDETTES.map(function (v, i) {
      return '<button type="button" class="mor__club" data-vedette="' + i + '">' + rond(v.nom) + '<small>' + esc(v.nom) + '</small></button>';
    }).join('') + '</div>';
  }

  function lienTout(q, n) {
    return '<a class="mor__tout" href="' + RACINE_URL + 'search?q=' + encodeURIComponent(preparer(q)) + '&type=product">Voir les ' + n + ' maillots →</a>';
  }

  function rendre() {
    var h = '', q = etat.q;
    if (etat.vue === 'accueil') {
      h = '<div class="mor__titre">Choisis ton équipe</div>' + grilleClubs();
    } else if (etat.vue === 'charge') {
      h = '<div class="mor__etat" role="status"><span class="mor__points" aria-hidden="true"><i></i><i></i><i></i></span><br>Recherche…</div>';
    } else if (etat.vue === 'erreur') {
      h = '<div class="mor__etat"><b>La recherche ne répond pas</b><a href="' + RACINE_URL + 'search?q=' + encodeURIComponent(q) + '&type=product">Ouvrir la page de recherche</a></div>';
    } else if (etat.vue === 'vide') {
      h = '<div class="mor__etat"><b>Rien pour « ' + esc(q) + ' »</b>Essaie le nom d’une équipe :</div>' + grilleClubs();
    } else if (etat.vue === 'resultats') {
      var g = groupes(etat.res.produits);
      h = '<div class="mor__titre">' + pluriel(etat.res.produits.length, 'maillot') + ' · ' + pluriel(g.length, 'équipe') + '</div>'
        + g.map(function (e) {
            return '<button type="button" class="mor__ligne" data-equipe="' + esc(e.nom) + '">' + rond(e.nom)
              + '<span><b>' + esc(e.nom) + '</b><small>' + pluriel(e.n, 'maillot') + '</small></span><i aria-hidden="true">→</i></button>';
          }).join('')
        + lienTout(q, etat.res.total);
    } else if (etat.vue === 'club') {
      var tous = etat.res.produits.filter(function (p) { return p.eq === etat.club; });
      var cats = {};
      tous.forEach(function (p) { cats[p.cat] = (cats[p.cat] || 0) + 1; });
      var presentes = ORDRE.filter(function (c) { return cats[c]; });
      var vus = etat.version === 'Tout' ? tous : tous.filter(function (p) { return p.cat === etat.version; });
      var retour = etat.depuis === 'resultats' ? '← Toutes les équipes pour « ' + esc(q) + ' »' : '← Toutes les équipes';
      h = '<button type="button" class="mor__retour" data-retour>' + retour + '</button>'
        + '<div class="mor__fiche">' + rond(etat.club) + '<div><b>' + esc(etat.club) + '</b><em>'
        + pluriel(tous.length, 'maillot') + ' · ' + pluriel(presentes.length, 'version') + '</em></div></div>'
        + (presentes.length > 1
            ? '<div class="mor__puces" role="group" aria-label="Versions">'
              + '<button type="button" class="mor__puce" data-version="Tout" aria-pressed="' + (etat.version === 'Tout') + '">Tout <small>' + tous.length + '</small></button>'
              + presentes.map(function (c) {
                  return '<button type="button" class="mor__puce" data-version="' + c + '" aria-pressed="' + (etat.version === c) + '">' + c + ' <small>' + cats[c] + '</small></button>';
                }).join('')
              + '</div>'
            : '')
        + '<div class="mor__grille">' + vus.map(carte).join('') + '</div>'
        + (etat.res.total > etat.res.produits.length ? lienTout(q, etat.res.total) : '');
    }
    zone.innerHTML = h;
  }

  /* ---- la loupe du site ouvre ce panneau ---- */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var t = e.target.closest('details-modal.header__search summary, .header__icon--search, [data-mo-recherche]');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    ouvrir(t);
  }, true);
})();